/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-floating-promises, react-hooks/exhaustive-deps, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any, @typescript-eslint/no-misused-promises, @typescript-eslint/strict-boolean-expressions */

import { Box, Typography } from '@mui/material';
import { SGKeyLevelsTable } from 'components/foundersNotes/custom_tags/SGKeyLevelsTable';
import { SGCustomTagType } from 'types';
import { useEffect, useState } from 'react';
import useHomeContent from 'hooks/home/useHomeContent';
import { Loader } from 'components';
import { Center } from 'components/shared/Center';
import { dayjs, nextBusinessDay } from 'util/shared';

const SGPropietaryLevels = () => {
  const [keyLevelsData, setKeyLevelsData] = useState<any>(null);
  const [errored, setErrored] = useState(false);
  const [loading, setLoading] = useState(false);

  const { getKeyLevelsData } = useHomeContent();

  const fetchData = async () => {
    try {
      setLoading(true);
      setErrored(false);
      const rawKeyLevelsData = await getKeyLevelsData();
      setKeyLevelsData(rawKeyLevelsData?.data);
    } catch (err) {
      setErrored(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Loader isLoading={loading}>
      {errored ? (
        <Center
          sx={{
            cursor: 'pointer',
          }}
        >
          <Typography onClick={fetchData} sx={{ fontSize: '14px' }}>
            Unfortunately, there was an error. Click here to try again.
          </Typography>
        </Center>
      ) : (
        <Box>
          {keyLevelsData && (
            <SGKeyLevelsTable
              data={{
                type: SGCustomTagType.SGPropKeyLevelsTable,
                data: keyLevelsData,
              }}
              updatedAt={`Updated at ${nextBusinessDay(
                dayjs.utc(keyLevelsData?.[0]?.keyLevelTradeDate),
              ).format('MM-DD')}`}
            />
          )}
        </Box>
      )}
    </Loader>
  );
};

export default SGPropietaryLevels;
